export default {"src":"/_next/static/media/0x1985365e9f78359a9b6ad760e32412f4a445e862.8f565d6b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};